import { Component, Renderer2, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent } from '../button.shared.component';

@Component({
    selector: 'shared-cart-clear-btn',
    templateUrl: './cart-clear-btn.shared.component.html',
    styleUrls: ['./cart-clear-btn.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearCartBtnComponent extends ButtonComponent {
    constructor(
        public renderer2: Renderer2,
        public elementRef: ElementRef,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super(renderer2, elementRef, changeDetectorRef);
    }
}
